import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Paper,
  useTheme,
  Alert
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'react-toastify';
import { ResetPassword } from '../../services/profile';

const ChangePassword = () => {
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();

  const handleResetPassword = async (e) => {
    e.preventDefault();
    
    try {
      if (newPassword !== confirmPassword) {
        toast.error(t('resetPassword.confirmNotMatch'));
        return;
      }

      const userEditProfile = {
        OldPasword: password,
        NewPasword: newPassword,
        confirmPassword: confirmPassword,
      };

      const response = await ResetPassword(userEditProfile);
      
      if (response.statusCode === 200) {
        toast.success(response.message);
        navigate(-1); // Go back
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(t('resetPassword.error'));
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        py: 4,
        px: 2,
        background: theme.palette.background.default
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={theme.palette.mode === 'dark' ? 3 : 1}
          sx={{
            p: { xs: 2, sm: 3 },
            borderRadius: 2,
            background: theme.palette.background.paper,
          }}
        >
          <Typography
            variant="h5"
            component="h1"
            gutterBottom
            align="center"
            color="primary"
            sx={{ mb: 4 }}
          >
            {t('resetPassword.title')}
          </Typography>

          <Box component="form" onSubmit={handleResetPassword} noValidate>
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label={t('resetPassword.oldPassword')}
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2
                }
              }}
            />

            <TextField
              margin="normal"
              required
              fullWidth
              name="newPassword"
              label={t('resetPassword.newPassword')}
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2
                }
              }}
            />

            <TextField
              margin="normal"
              required
              fullWidth
              name="confirmPassword"
              label={t('resetPassword.confirmPassword')}
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              error={newPassword !== confirmPassword && confirmPassword !== ''}
              helperText={
                newPassword !== confirmPassword && confirmPassword !== ''
                  ? t('resetPassword.confirmNotMatch')
                  : ''
              }
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2
                }
              }}
            />

            <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => navigate(-1)}
                sx={{ py: 1.5 }}
              >
                {t('resetPassword.Back')}
              </Button>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ py: 1.5 }}
              >
                {t('resetPassword.Submit')}
              </Button>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default ChangePassword; 